// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/slick-theme.css
// module id = 1278
// module chunks = 34